import { render, staticRenderFns } from "./email-shortcodes.vue?vue&type=template&id=177d875a&scoped=true"
import script from "./email-shortcodes.vue?vue&type=script&lang=js"
export * from "./email-shortcodes.vue?vue&type=script&lang=js"
import style0 from "./email-shortcodes.vue?vue&type=style&index=0&id=177d875a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d875a",
  null
  
)

export default component.exports